import type { ReactNode, FC } from 'react';
import cn from 'classnames';
import { sanitizeHref } from '@wix/da-url';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import s from './BaseCard.scss';

interface Props {
  className?: string;
  actionsWrapperClassName?: string;
  thumbClassName?: string;
  width: number;
  height: number;
  thumb: ReactNode;
  label: ReactNode;
  labelSuffix?: ReactNode;
  complexLabel?: boolean;
  actions?: ReactNode;
  icons?: ReactNode;
  ribbon?: ReactNode;
  href?: string;
  onClick?: () => void;
  biData?: any;
  innerRef?: (node: HTMLElement | null) => void;
}

const BaseCard: FC<Props> = ({
  className,
  actionsWrapperClassName,
  thumbClassName,
  width,
  height,
  thumb,
  label,
  labelSuffix,
  complexLabel,
  actions,
  href,
  onClick,
  biData,
  innerRef,
  ribbon,
  icons,
}) => {
  return (
    <PlainButtonOrLink
      className={cn(s['root'], className)}
      style={{ width }}
      href={sanitizeHref(href)}
      onClick={onClick}
      biData={biData}
      innerRef={innerRef}
    >
      {ribbon}
      {icons && (
        <>
          <div className={s['icon-underlay']} />
          <div className={s['top-right-icons']}>{icons}</div>
        </>
      )}
      <div className={cn(s['thumb'], thumbClassName)} style={{ width, height }}>
        {thumb}
      </div>
      <div className={cn(s['details'], complexLabel && s['complex-details'])}>
        <div className={s['label']}>
          {label}
          {labelSuffix && ' '}
          {labelSuffix}
        </div>
        {actions && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            className={actionsWrapperClassName}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </PlainButtonOrLink>
  );
};
BaseCard.displayName = 'BaseCard';

export default BaseCard;
